import { Category } from "./category";
import { Photo } from "./photo";
import { SystemField } from "./system-field";
import { User } from "./user";

export class Post  extends SystemField{
     
	is_draft?: number;
	author_id?: string;
	posted_at?: string;
	code?: string;
	main_photo?: string;
	status?: string;
	slug?: string;
	category_ids?: string;
	tag_ids?: string;
	media_link?: string;
	is_top?: number;
	is_new?: number;
	ordering?: number;
	is_video?: number;
	record_type_id?: string;
	record_type?: string;
	photos?: Photo[];
	is_active?: number;
	expiry_date?: string;
	lstPhotoDelIds?: string[];

	// Formular Fields
	main_photo_file?: File;
	main_photo_preview?: string;
	categories?: Category[];
	photo_files?: File[];
	photo_preview?: string;

	// Callback class
	author?: User;

	// Import class translate
	langs?: any;
}

export class PostsTranslate  extends SystemField{
	lang_code?: string;
	title?: string;
	short_desc?: string;
	posts_id?: string;
	contents?: Blob;
	meta_title?: string;
	meta_desc?: string;
	meta_keyword?: string;
	description?: string;
	note?: string;
	subtitle?: string;
}

export class PublicPosts extends Post{}